import { Component, Input } from '@angular/core';
import { CustomFlexLayoutModule } from '../../flex-layout/custom-flex-layout.module';
import { EditorTextChildComponent } from './editor-text-child/editor-text-child.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'calsoft-text-editor',
  imports: [CustomFlexLayoutModule,EditorTextChildComponent,MatIconModule],
  templateUrl: './editor-text.component.html',
  styleUrl: './editor-text.component.scss'
})
export class EditorTextComponent {
 trustedHtmlContent: any;

  @Input() text: any;

  @Input() align: any;

  @Input() data: any;

  @Input() fontSize: any;

  @Input() MobfontSize: any;

  @Input() fontFamily: any;

  @Input() id: any;

  @Input() matIcon: any = 'check_circle';

  arry: any=[];
  
  icon: boolean | undefined;

  constructor(
 

  ) {
    
  }

  ngOnInit() {

    if(this.text.includes('ul')){
      this.icon=true;
    }else{
      this.icon=false;
    }
    const containsUlAndLiTags = this.checkUlAndLiTags(this.text);
    if (!containsUlAndLiTags) {
    //  console.log(this.text);
    this.text = this.text.replace(/<ul>/g, '')
    .replace(/<\/?li>/g, '')
    .replace(/<\/?p>/g, '')
    .replace(/<br>/g, '');

    this.arry = this.text.split('</ul>');
    this.arry = this.arry.filter((item: string) => item.trim() !== '');  

    if(this.arry.length==1){
      this.icon=false;
    }
  }else{
    this.text = this.text.replace(/<ul>/g, '')
    .replace(/<br>/g, '')
    .replace(/<li>/g, '')
    .replace(/<p>/g, '')
    ;

    this.arry = this.text.split('</p></li>');

    this.arry.splice(this.arry.length-1, 1);


    //console.log(this.arry);
    

  }
  }

  checkUlAndLiTags(input: string): boolean {
    const ulLiPattern = /<ul>\s*(<li>.*<\/li>\s*)+<\/ul>/;
    return ulLiPattern.test(input);
  }

}
